import * as i0 from '@angular/core';
import { NgModule, Injectable, Inject } from '@angular/core';
import * as i2 from '@upr-web-primer/locale';
import * as i4 from '@upr-web-primer/spinner';
import * as i3 from '@upr-web-primer/storage';
import * as i1 from '@upr-web-primer/tcm-service';
import { clone, get } from 'lodash-es';
import { BehaviorSubject } from 'rxjs';

class GdsVenueTilesModule {
}
GdsVenueTilesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsVenueTilesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
GdsVenueTilesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsVenueTilesModule });
GdsVenueTilesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsVenueTilesModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsVenueTilesModule, decorators: [{
            type: NgModule
        }] });

class GdsVenueTilesService {
    constructor(appDefaults, tridionDefaults, publication, tcm, localeService, sessionStorage, spinner) {
        this.appDefaults = appDefaults;
        this.tridionDefaults = tridionDefaults;
        this.publication = publication;
        this.tcm = tcm;
        this.localeService = localeService;
        this.sessionStorage = sessionStorage;
        this.spinner = spinner;
        this.tiles$ = new BehaviorSubject(null);
        const locale = this.localeService.getFromStorage();
        this.language = locale.language;
        this.country = locale.country;
        this.init();
    }
    init() {
        const sessionTiles = this.sessionStorage.getItem(`${this.publication}_${this.language}_TILES_RESULT`);
        if (!!sessionTiles) {
            this.tiles = sessionTiles;
            return this.tiles$.next(this.tiles);
        }
        this.getTiles();
    }
    getTiles() {
        const filtersUrl = this.appDefaults.FILTER_TILES.replace('%language%', this.language).replace('%country%', this.country);
        let response = {};
        this.spinner.show();
        this.tcm
            .request(filtersUrl)
            .then(data => {
            if (!data) {
                throw new Error('no filter list data found');
            }
            response = clone(data);
            const tiles = response && response.Tiles ? response.Tiles : [];
            return Promise.resolve(tiles);
        })
            .then((data) => {
            response.Tiles = this.mapTileDetailUrl(data);
            const properties = response && response.Properties ? response.Properties : [];
            return Promise.resolve(properties);
        })
            .then((data) => {
            response.Properties = data.map((tile) => {
                tile.Content.TileImage = {
                    HightResolutionImage: tile.Content.MainImage.Image
                };
                tile.cardDetailUrl = get(tile, 'PageUrl', '').replace('/' + this.tridionDefaults.TRIDION_SITE + '/', '/');
                return tile;
            });
            const hotels = response && response.Hotels ? response.Hotels : [];
            response.Hotels = this.mapTileDetailUrl(hotels);
            this.sessionStorage.setItem(`${this.publication}_${this.language}_TILES_RESULT`, response, {
                expiresIn: 30,
                unit: 'minutes'
            });
            this.tiles = response;
            this.tiles$.next(this.tiles);
        })
            .catch(error => console.error(error))
            .then(() => this.spinner.hide());
    }
    getByTcmId(tcmId) {
        return (get(this.tiles, 'Tiles', []).find((tile) => tile.TcmId === tcmId) ||
            get(this.tiles, 'Properties', []).find((tile) => tile.TcmId === tcmId) ||
            get(this.tiles, 'Hotels', []).find((tile) => tile.TcmId === tcmId) ||
            {});
    }
    mapTileDetailUrl(tiles) {
        return tiles.map((tile) => {
            tile.cardDetailUrl = get(tile, 'PageUrl', '').replace('/' + this.tridionDefaults.TRIDION_SITE + '/', '/');
            return tile;
        });
    }
}
GdsVenueTilesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsVenueTilesService, deps: [{ token: 'AppDefaults' }, { token: 'TridionDefaults' }, { token: 'TridionSite' }, { token: i1.TcmService }, { token: i2.LocaleService }, { token: i3.SessionStorageService }, { token: i4.SpinnerService }], target: i0.ɵɵFactoryTarget.Injectable });
GdsVenueTilesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsVenueTilesService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsVenueTilesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['AppDefaults']
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['TridionDefaults']
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['TridionSite']
                }] }, { type: i1.TcmService }, { type: i2.LocaleService }, { type: i3.SessionStorageService }, { type: i4.SpinnerService }]; } });

export { GdsVenueTilesModule, GdsVenueTilesService };
